export type AsyncStatus = "idle" | "loading" | "success" | "empty" | "error";

export class ApiError extends Error {
  readonly status: number | null;
  readonly code: string | null;
  readonly endpoint: string;
  readonly retryAfterMs: number | null;

  constructor(
    message: string,
    options: {
      code?: string | undefined;
      endpoint?: string | undefined;
      retryAfterMs?: number | undefined;
      status?: number | undefined;
    } = {},
  ) {
    super(message);
    this.name = "ApiError";
    this.status = options.status ?? null;
    this.code = options.code ?? null;
    this.endpoint = options.endpoint ?? "";
    this.retryAfterMs = options.retryAfterMs ?? null;
  }
}

export interface OkResponse {
  ok: boolean;
}
